module.exports = __webpack_public_path__ + "media/images/front/materials/madera-c093f8900653d58499d2e448c921408b.jpg";